import { render } from "./App.vue?vue&type=template&id=450717a0"
const script = {}

import exportComponent from "/Users/bellliu/code/saikesi/sksnetruck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__